import {
  callApiDangNhap,
  callApiSyncData,
  callApiLayTinhThanh,
  callApiLayDanhSachLevel,
  callApiGetPermission,
  callApiChangeGenerateSetupCode,
  callApiConfirmUsing,
  callApiValidateLogin,
  callApiRegisterDevice,
  callApiConfirmDevice,
  callApiListDevice,
  callApiSetPrimary,
  callApiLockDevice,
  callApiUnlockDevice,
  callApiListDeviceByUser,
  callApiRevokeDevice,
  callApiReactivate2Fa,
  callApiDisable2Fa,
  callApiEnable2Fa,
  callApiGetOtpConfig,
  callApiUpdateOtpConfig,
  callApiIssueActivation,
  callApiVerifyActivation,
  callApiRequestActivation,
  callApiSearchOtpAudit,
  callApiExportOtpAudit,
  callApiGetOtpReasonCatalog,
  callApiPollLoginApproval,
  callApiCompleteLogin,
  callApiMintEnrollTicket,
  callApiGetPendingEnroll,
  callApiConfirmEnrollBinding,
  callApiMintAddDeviceTicket,
  callApiGetStepUpPolicies,
  callApiUpdateStepUpPolicies,
  callApiSearchStepUpPolicyHistory,
} from "@/api/common";
import {
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";

const setIsLogin = (context, isLogin) => {
  setValueToStorageByKey(LOCAL_STORAGE_KEY.IS_LOGIN, isLogin);
  context.commit("SET_IS_LOGIN", isLogin);
};
const login = (context, payload) => {
  return callApiDangNhap(payload);
};

const setPermission = (context) => {
  let payload = {
    appCode: "COMMON",
  };
  return callApiGetPermission(payload).then((res) => {
    let listPermission = res.data.data;
    context.commit("SET_LIST_PERMISSION", listPermission);
    setValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSIONS, listPermission);
  });
};

const setBreadcrumb = (context, breadcrumb) => {
  context.commit("SET_BREADCRUMB", breadcrumb);
};

const setAppId = (context, appId) => {
  setValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID, appId);
  context.commit("SET_APP_ID", appId);
};

const setIsIframe = (context, payload) => {
  setValueToStorageByKey("isIframe", payload);
  context.commit("SET_IS_IFRAME", payload);
};

const setUserInfo = (context, userInfo) => {
  context.commit("SET_USER_INFO", userInfo);
};

const syncData = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSyncData()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTinhThanh = async (context, payload) => {
  const response = await callApiLayTinhThanh(payload.data);
  if (response && response.data.succeeded) {
    payload.onSuccess && payload.onSuccess(response.data.data);
  }
};

const layDanhSachLevel = async (context) => {
  const response = await callApiLayDanhSachLevel();
  if (response && response.data.succeeded) {
    context.commit("SET_LIST_LEVEL", response.data.data);
  }
};

const changeGenerateSetupCode = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiChangeGenerateSetupCode()
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response)
        });
  });
};

const validateLogin = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiValidateLogin(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response)
        });
  });
};

const confirmUsing = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiConfirmUsing(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response)
        });
  });
};

// Phase 5b-2: provisioning thiết bị 2FA đa-thiết-bị.
const registerDevice = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiRegisterDevice(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const confirmDevice = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiConfirmDevice(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const listDevice = (context) => {
  return new Promise((resolve, reject) => {
    callApiListDevice()
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// Phase 7B-1 UC13: cấu hình bảo mật OTP. Resolve response.data (ServiceResponse camelCase) như device actions.
const getOtpConfig = (context) => {
  return new Promise((resolve, reject) => {
    callApiGetOtpConfig()
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const updateOtpConfig = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateOtpConfig(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// Phase 7C UC11: admin cấp mã kích hoạt + user verify. Resolve response.data (camelCase) như các action common.
const issueActivation = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiIssueActivation(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const verifyActivation = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiVerifyActivation(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// Phase 9b UC6: user tự yêu cầu cấp mã kích hoạt cho email của mình (self-service).
const requestActivationSelf = (context) => {
  return new Promise((resolve, reject) => {
    callApiRequestActivation()
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// GAP 7.4: đặt thiết bị Active của chính user làm primary. Resolve response.data (ServiceResponse camelCase).
const setPrimary = (context, deviceId) => {
  return new Promise((resolve, reject) => {
    callApiSetPrimary(deviceId)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// Phase 10 UC12: admin khoá/mở + xem thiết bị OTP của user khác. Resolve response.data (camelCase).
// Payload lock/unlock: { userId, deviceId, twoFactorCode, adminDeviceId }.
const lockDevice = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLockDevice(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const unlockDevice = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUnlockDevice(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const listDeviceByUser = (context, userId) => {
  return new Promise((resolve, reject) => {
    callApiListDeviceByUser(userId)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// UC7.5: hủy 1 thiết bị (soft-state). Payload: { userId, deviceId, twoFactorCode, authorizerDeviceId }.
const revokeDevice = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiRevokeDevice(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// UC10.4: kích hoạt lại tài khoản đã vô hiệu (atomic). Payload: { userId, twoFactorCode, deviceId, reason }.
const reactivate2Fa = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiReactivate2Fa(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// OFF 2FA per-user (Approach A - 2026-08-11): admin vô hiệu 2FA của user khác (step-up OTP admin +
// reason BAT BUOC). Payload: { userId, twoFactorCode, deviceId, reason }. Resolve response.data
// (ServiceResponse camelCase {succeeded, message, data}).
const disable2Fa = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDisable2Fa(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// Đối xứng disable2Fa: bật lại 2FA cho user (clear exempt + revoke phiên cũ).
const enable2Fa = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiEnable2Fa(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// Phase 8 UC17: nhật ký OTP. search -> response.data (ServiceResponse camelCase); export -> full response (blob).
const searchOtpAudit = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSearchOtpAudit(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// GAP 17.1 INFO: lấy catalog Reason từ BE (giảm duplicate map JS). Fail -> caller dùng fallback cứng.
const getOtpReasonCatalog = () => {
  return new Promise((resolve, reject) => {
    callApiGetOtpReasonCatalog()
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const exportOtpAudit = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiExportOtpAudit(payload)
        .then((response) => resolve(response)) // full response: response.data = Blob
        .catch((error) => reject(error.response));
  });
};

// Phase 07 (Push Approval login-web): poll trạng thái attempt duyệt qua app QLVB.
// payload: { loginAttemptId, pollSecret, stage1Token }.
const pollLoginApproval = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiPollLoginApproval(payload.loginAttemptId, payload.pollSecret, payload.stage1Token)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// Phase 07: mint token 24h đầy đủ sau khi attempt approved (RT-1).
// payload: { loginAttemptId, pollSecret, stage1Token }.
const completeLogin = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCompleteLogin(
        { loginAttemptId: payload.loginAttemptId, pollSecret: payload.pollSecret },
        payload.stage1Token
    )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// P2 QR handoff (3 action web-phiên). Resolve response.data (ServiceResponse camelCase {data, succeeded, message}).
const mintEnrollTicket = (context) => {
  return new Promise((resolve, reject) => {
    callApiMintEnrollTicket()
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const getPendingEnroll = (context) => {
  return new Promise((resolve, reject) => {
    callApiGetPendingEnroll()
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

const confirmEnrollBinding = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiConfirmEnrollBinding(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// UC7.4 port QTHT: thêm thiết bị dự phòng post-login. payload {authorizerOtp, authorizerDeviceId}.
// Resolve response.data (ServiceResponse camelCase {data:{ticketId,expiresInSeconds}, succeeded, message}).
const mintAddDeviceTicket = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiMintAddDeviceTicket(payload.authorizerOtp, payload.authorizerDeviceId)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// UC14 Phase 2: cau hinh step-up theo chuc nang. Res GET la flat bool {kySo, pheDuyet, thuHoi, capQuyen}
// (KHONG phai mang policies[]). Resolve response.data (ServiceResponse camelCase) nhu getOtpConfig.
const getStepUpPolicies = (context) => {
  return new Promise((resolve, reject) => {
    callApiGetStepUpPolicies()
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// payload: tung field optional {kySo?, pheDuyet?, thuHoi?, capQuyen?} - null/undefined = giu nguyen o BE.
const updateStepUpPolicies = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateStepUpPolicies(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

// payload paging: { pageIndex, pageSize }. Res PagedResult.Items = [{ id, actionType, enabled, changedBy, changedByName, createdAt }].
const searchStepUpPolicyHistory = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSearchStepUpPolicyHistory(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
  });
};

export default {
  setIsLogin,
  login,
  setBreadcrumb,
  setAppId,
  setUserInfo,
  syncData,
  layTinhThanh,
  layDanhSachLevel,
  setPermission,
  setIsIframe,
  changeGenerateSetupCode,
  validateLogin,
  confirmUsing,
  registerDevice,
  confirmDevice,
  listDevice,
  setPrimary,
  getOtpConfig,
  updateOtpConfig,
  issueActivation,
  verifyActivation,
  requestActivationSelf,
  lockDevice,
  unlockDevice,
  listDeviceByUser,
  revokeDevice,
  reactivate2Fa,
  disable2Fa,
  enable2Fa,
  searchOtpAudit,
  exportOtpAudit,
  getOtpReasonCatalog,
  pollLoginApproval,
  completeLogin,
  mintEnrollTicket,
  getPendingEnroll,
  confirmEnrollBinding,
  mintAddDeviceTicket,
  getStepUpPolicies,
  updateStepUpPolicies,
  searchStepUpPolicyHistory,
};
